import { Flex } from 'antd';

import { formatNumber } from '@suntex.core/utils';
import { isAuthenticated, useAuth } from '@suntex.fim/auth/react';
import { PlayerAvatar } from '@suntex.fim/avatar';
import { LoginType } from '@suntex.fim/enums';
import { getFlags } from '@suntex.fim/flags';
import { useTheme } from '@suntex.fim/ui';

import { BuildingIcon, FireIcon, StarIcon } from '../assets/images';
import { usePlayer } from '../hooks';

import { ChangeGradeButton } from './ChangeGradeButton';

export function PlayerProfile() {
  const { info, progressSummary, playerInfo } = usePlayer();
  const { login } = useAuth(isAuthenticated);
  const { colors } = useTheme();
  const flags = getFlags();

  const isIndividual = login.loginType === LoginType.IndividualPlayer;

  const iconProps = {
    style: {
      width: '1.5em',
    },
  };
  const labelProps = {
    gap: 10,
    align: 'center',
    style: {
      color: colors.subtle,
    },
  };
  const datumProps = {
    style: {
      fontSize: '1.2em',
    },
  };

  return (
    <Flex vertical gap={10} style={{ width: '100%' }}>
      <Flex justify="center">
        <span
          {...{
            style: {
              fontSize: '1.5em',
              fontWeight: 'bold',
            },
          }}
        >
          {info.userId}
        </span>
      </Flex>
      <PlayerAvatar
        params={
          info.avatar
            ? {
                stickers: progressSummary.stickers,
                badgeIcon: info.avatar.badgeIcon,
                badgeBackground: info.avatar.badgeBackground,
              }
            : undefined
        }
      />
      <Flex vertical gap={5}>
        {!isIndividual && (
          <Flex justify="space-between">
            <Flex {...labelProps}>
              <BuildingIcon {...iconProps} />
              My Team:
            </Flex>
            <span {...datumProps}>{info.team.name ?? ''}</span>
          </Flex>
        )}
        <Flex gap={10} justify="space-between">
          <Flex {...labelProps}>
            <StarIcon {...iconProps} />
            My Stickers:
          </Flex>
          <span {...datumProps}>{formatNumber(progressSummary.stickers)}</span>
        </Flex>
        {flags.player.streaks && (
          <Flex gap={10} justify="space-between">
            <Flex {...labelProps}>
              <FireIcon {...iconProps} />
              Current Streak:
            </Flex>
            <span {...datumProps}>
              {progressSummary.currentStreak || 0} day
              {progressSummary.currentStreak === 1 ? '' : 's'}
            </span>
          </Flex>
        )}
        {isIndividual && playerInfo?.expiration.playEnds && (
          <Flex gap={10} justify="space-between">
            <Flex {...labelProps}>Membership Expires:</Flex>
            <span {...datumProps}>
              {formatExpiration(playerInfo.expiration.playEnds)}
            </span>
          </Flex>
        )}
        {isIndividual && <ChangeGradeButton />}
      </Flex>
    </Flex>
  );
}

function formatExpiration(date: Date): string {
  const d = new Date(date);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const year = d.getFullYear();
  return `${month}/${day}/${year}`;
}
